export type KnowledgeDiscoverySearchChatIntentDetectionModelVersionType =
	(typeof KnowledgeDiscoverySearchChatIntentDetectionModelVersion)[keyof typeof KnowledgeDiscoverySearchChatIntentDetectionModelVersion];

/** Model versions accepted by the Search/Chat intent detection endpoint. */
export const KnowledgeDiscoverySearchChatIntentDetectionModelVersion = {
	GEMMA3_1B_SCI_V1: 'GEMMA3_1B_SCI_V1',
	GEMMA4_E2B_SCI_V1: 'GEMMA4_E2B_SCI_V1',
} as const;
